import React, { FC, useEffect, useState } from 'react';
import { Input, Switch } from '@cokitchen/cokitchen-components';
import { DepartmentType, MemberType } from './types';
import SelectDropdown from 'components/base/select-dropdown';
import BirthdayInput from 'components/base/birthday-input';
import CurrencyInput from 'components/base/currency-input';
import { toTitleCase } from 'utils/functions';
import './styles.scss';

const budgetDurationOptions = [
  { name: 'Daily', id: 'Daily' },
  { name: 'Weekly', id: 'Weekly' },
  { name: 'Monthly', id: 'Monthly' }
];
const budgetSettingOptions = [
  // { name: 'One Off', id: 'ONE OFF' },
  { name: 'Roll Over', id: 'ROLL OVER' },
  { name: 'Recurring', id: 'RECURRING' }
];

type AddNewMemberProps = {
  memberData: MemberType;
  setMemberData: (memberData: MemberType) => void;
  handleDelete: () => void;
  showRemoveButton: boolean;
  departmentOptions: DepartmentType[];
  dpt: DepartmentType | undefined;
};

const AddMemberForm: FC<AddNewMemberProps> = ({
  memberData,
  setMemberData,
  handleDelete,
  showRemoveButton,
  departmentOptions,
  dpt
}) => {
  const [department, setDepartment] = useState<DepartmentType | undefined>(dpt || undefined);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    const { name, value } = target;
    setMemberData({
      ...memberData,
      [name]: value
    });
  };
  useEffect(() => {
    setMemberData({ ...memberData, department_name: department?.name });
  }, [department]);
  const handleSelectDate = (date: Date | undefined) => {
    if (!date) return;
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    const updatedMemberDataForm = { ...memberData };
    updatedMemberDataForm.dob = newDate.toISOString().split('T')[0];
    setMemberData(updatedMemberDataForm);
  };

  return (
    <div className='max-w-[396px] text-sm space-y-4 border-b border-[#E9EAEC] py-4'>
      {showRemoveButton && (
        <div
          onClick={handleDelete}
          className='text-[#E60A2B] text-sm my-2 cursor-pointer ml-5 flex justify-end gap-1'>
          - <span>Remove member</span>
        </div>
      )}
      <div className='flex gap-2 flex-wrap w-full justify-between h-fit'>
        <div className='w-full sm:w-[48%] relative'>
          <Input
            design='bordered'
            type='text'
            label='First Name'
            name='first_name'
            value={memberData.first_name}
            onChange={handleChange}
            placeholder='Donatus'
            className='label-asterisk-red after:ml-[4.6rem]'
          />
        </div>

        <div className='w-full sm:w-[48%] relative'>
          <Input
            design='bordered'
            type='text'
            label='Last Name'
            name='last_name'
            value={memberData.last_name}
            onChange={handleChange}
            placeholder='Globus'
            className='label-asterisk-red after:ml-[4.6rem]'
          />
        </div>
      </div>
      <div className='relative'>
        <Input
          design='bordered'
          type='phone'
          label='Mobile Number'
          name='phone_number'
          value={memberData.phone_number}
          onChange={handleChange}
          placeholder='07018135214'
          className='label-asterisk-red after:ml-[6.5rem]'
        />
      </div>
      <div className='relative'>
        <Input
          design='bordered'
          type='email'
          label='Email'
          name='email'
          value={memberData.email}
          onChange={handleChange}
          placeholder='donatusglobus13@gmail.com'
          className='label-asterisk-red after:ml-10'
        />
      </div>
      <div className='relative'>
        <SelectDropdown
          value={department?.name}
          setValue={setDepartment}
          placeholder='Select department'
          options={departmentOptions}
          label='Department'
          required
        />
      </div>
      <BirthdayInput value={memberData.dob} handleSelectDate={handleSelectDate} />
      <div className='flex w-full justify-between gap-2'>
        <div className='w-full sm:w-[48%]'>
          <CurrencyInput
            label='Set a budget'
            value={memberData.budget}
            onChange={(budget) => {
              setMemberData({
                ...memberData,
                budget
              });
            }}
            placeholder='50,000'
          />
        </div>
        <div className='w-full sm:w-[48%] mt-[-8px]'>
          <SelectDropdown
            label='Budget Duration'
            value={memberData?.budget_duration}
            setValue={(option) => {
              setMemberData({ ...memberData, budget_duration: option.name });
            }}
            placeholder='Daily'
            options={budgetDurationOptions}
          />
        </div>
      </div>
      <SelectDropdown
        value={toTitleCase(memberData?.budget_setting)}
        setValue={(option) =>
          setMemberData({
            ...memberData,
            budget_setting: option.id
          })
        }
        placeholder='Select Budget Setting'
        options={budgetSettingOptions}
        label='Budget Setting'
      />
      <p className='text-xs text-[#96999C]'>All fields are required*</p>
      <div className='flex gap-4'>
        <div className=''>
          <p className='text-[16px] font-semibold'>Assign this person as an admin</p>
          <p className='text-[#6F7376] text-sm'>
            The designated employee must accept this role via email
          </p>
        </div>
        <Switch
          active={memberData.role === 'ADMIN'}
          onChange={() => {
            memberData.role === 'ADMIN'
              ? setMemberData({ ...memberData, role: 'MEMBER' })
              : setMemberData({ ...memberData, role: 'ADMIN' });
          }}
        />
      </div>
    </div>
  );
};

export default AddMemberForm;
